<template>
    <div class="input-group ">
        <input class="form-control py-2" type="search"
            v-model.trim="resoursetosearch" placeholder="Búsqueda"
            id="example-search-input" v-on:input="changeResource">
            <span class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" @click="searchResource">
                    <i class="fa fa-search"></i>
                </button>
            </span>
    </div>
</template>
<script>
export default {
  name: 'resourceSearch',
  props: ['routeApi', 'perPage', 'newTags2'],
  data() {
    return {
      resoursetosearch: null,
      onPressSearch: false, // Me indica que al menos una vez se presiono el botón Search. Me sirve para hacer un reload de la grilla
    };
  },
  methods: {
    /**
     * Controlar cuando presiona x get todos los objetos
     */
    changeResource() {
      if (this.resoursetosearch.length === 0 && this.onPressSearch) {
        this.searchResource();
        this.onPressSearch = false;
      }
    },
    /**
     * Buscar recurso por textos
     */
    async searchResource() {
      this.onPressSearch = true;
      this.$emit('loading', true);
      try {
        const response = await this.axios.get(this.routeApi, {
          params: {
            currentPage: 1,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.resoursetosearch,
          },
        });
        const arows = response.data.rows;
        const data = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.$emit('update', arows, data);
        this.$emit('loading', false);
      } catch (e) {
        this.$emit('loading', false);
      }
    },
  },
};
</script>
